export default axios => ({
  /**
   * Список пользователей
   *
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  users ({ pageSize = 10, currentPage = 1, searchBy = null, sort = 'id', order = 'DESC' } = {}) {
    const body = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get('/web/user/list', {
      params: body
    })
  },
  /**
   * Данные пользователя
   *
   * @param userId
   * @returns {*}
   */
  user (userId) {
    return axios.get('/web/user/get/' + userId)
  },
  /**
   * Метод добавляет нового пользователя
   *
   * @param name
   * @param username
   * @param email
   * @param phone
   * @param password
   * @param role
   * @returns {*}
   */
  createUser ({ name, username, email, phone, password, role }) {
    return axios.post('/web/user/add', { name, username, email, phone, password, role })
  },
  /**
   * Список пользователей, находящихся в черном списке
   *
   * @param pageSize
   * @param currentPage
   * @param searchBy
   * @param sort
   * @param order
   * @returns {*}
   */
  blackList ({ pageSize = 10, currentPage = 1, searchBy = '', sort = 'id', order = 'DESC' } = {}) {
    const body = {
      pageSize: pageSize,
      pageIndex: currentPage,
      search: searchBy,
      sort: sort,
      order: order
    }

    return axios.get('/web/user/blackList', body)
  },
  /**
   * Добавляет пользователя в черный список
   *
   * @param userId
   * @returns {*}
   */
  block (userId) {
    return axios.post(`/web/user/get/${userId}/block`)
  },
  /**
   * Убирает пользователя из черного списка
   *
   * @param userId
   * @returns {*}
   */
  unblock (userId) {
    return axios.delete(`/web/user/get/${userId}/unblock`)
  },
  /**
   * Загружает аватарку
   *
   * @param userId
   * @param base64File
   * @returns {*}
   */
  uploadAvatar ({ userId, base64File }) {
    return axios.post(`/web/user/get/${userId}/avatar`, { base64File })
  },
  /**
   * Список друзей
   *
   * @param userId
   * @returns {*}
   */
  friends (userId) {
    return axios.get(`/web/user/get/${userId}/friends`)
  },
  /**
   * Список команд
   *
   * @param userId
   * @returns {*}
   */
  team (userId) {
    return axios.get(`/web/user/get/${userId}/teams`)
  },
  /**
   * Список событий
   *
   * @param userId
   * @returns {*}
   */
  events (userId) {
    return axios.get(`/web/user/get/${userId}/events`)
  },
  /**
   * @param userId
   * @returns {*}
   */
  positions (userId) {
    return axios.get(`/web/user/get/${userId}/edit/option`)
  },
  /**
   * Метод изменяет Данные пользователя
   *
   * @param userId
   * @param body
   * @returns {*}
   */
  edit (userId, body) {
    return axios.put(`/web/user/get/${userId}/edit`, body)
  }
})
